<app-filter-chip-list
    *ngIf="showChipList() | async"
    [chipValues]="filterChipValues"
    (chipRemoved)="handleChipRemoved($event)"
    (chipListEvent)="handleChipListEvent()"
    (moreFiltersClick)="handleFilter()"
    fxLayout="column"
></app-filter-chip-list>
